<template>
	<div class="progress-bar-container">
		<div class="progress-lines">
			<span
				v-for="q in (quantity - 1)"
				:key="q"
				:style="`border-right: 2px solid ${$appColors.gray};width: calc(100% / ${quantity});`"
			></span>
		</div>
		<v-progress-linear
			class="my-0"
			color="primary"
			height="5"
			background-color="gray"
			:value="value"
		></v-progress-linear>
	</div>
</template>

<script>
	export default {
		name: 'progress-bar',
		props: {
			quantity: {
				default: 10,
				type: Number,
			},
			value: {
				default: 0,
				type: Number,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.progress-bar-container {
		position: relative;
		width: 100%;
	}

	.v-progress-linear {
		border-radius: 15px;
		top: -5px;
	}

	.progress-lines {
		align-items: center;
		background-color: transparent;
		display: flex;
		height: 5px;
		position: relative;
		width: 100%;
		z-index: 2;

		span {
			height: 5px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/progress-bar.vue